import React, { useState, useEffect } from 'react';
import { Grid, Paper, IconButton, Box, Table, TableCell, TableRow, Chip, Tooltip, Typography, Stack, Button, Menu, MenuItem, useMediaQuery } from '@mui/material';
import { styled } from '@mui/system';
import {
  Accessibility,
  ArrowDropDown,
  ArrowRight,
  CheckCircleOutline,
  Circle,
  Delete,
  DirectionsRun,
  DoDisturbAlt,
  KeyboardArrowDown,
  KeyboardArrowRight,
  Edit,
  CheckCircle,
  Cancel,
 MoreVert,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { settingsClose } from '../../redux/reducers/companySkipSave';
import { handleFreeze } from '../../utils/common';
import { useNavigate } from 'react-router-dom';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { showWarningSnackbar } from '../snackBar/snakbar';
import { useThemes } from '../Theme/theme';
import VoucherBtn from '../Buttons/VoucherBtn';
import VoucherBTNnew from '../Buttons/VoucherBTNnew';


export const RecursiveTreeItem = ({
  row,
  setItemModal,
  setItemDetails,
  setParent,
  setCreateLedgerModal,
  setMainCategory,
  setCreateGroupModal,
  setActiveValueModal,
  setDeleteItemModal,
  newAddedCategoryId,
  expandedItems,
  saveSkipStatus,
  handleToggle,
  isExpand,
  borderRightColor,
  hideGroupTotal,
  isUpdatingItem,
  isServicesSection = false,
  handleClosingStockClick,
}) => {
  const { theme } = useThemes();
  const isMobile = useMediaQuery(theme.breakpoints.down(900));
  const [anchorEl, setAnchorEl] = useState(null);
  const [visi, setVisi] = useState(true);
  const open = Boolean(anchorEl);

  const commonStyle = {
    rowHeight: 45,
    fontSize: 15,
  };
  const commonTableCell = {
    padding: 0,
    margin: 0,
    borderRight: '4px solid',
    borderRightColor: theme?.palette?.TmId.id.toString().includes('9') ? theme.palette.primary.black : '#EEEEFA',
    backgroundColor: 'transparent !important',
  };

  const isCategory = row?.category === 'Category';
  const hasChildren = row?.children && row?.children?.length > 0;
  const Freeze = useSelector((state) => state.userPrefrenceandReducer?.financialYear?.freezestatus);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleClick = (event) => {
    setVisi(true)
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setVisi(false)
  };

  const handleEditAction = () => {
    if (Freeze == 1) {
      return handleFreeze();
    }
    if (isUpdatingItem) {
      return showWarningSnackbar('Please wait, updating item...');
    }
    setItemModal(true);
    setItemDetails({
      itemId: row?.id,
      type: row?.type,
      view: false,
      name: row?.name,
    });
    handleClose();
  };

  const handleDeleteAction = () => {
    if (Freeze == 1) {
      return handleFreeze();
    }
    if (isUpdatingItem) {
      return showWarningSnackbar('Please wait, updating item...');
    }
    setItemDetails({
      data: {
        itemId: row?.id,
        type: row?.type,
        view: false,
        name: row?.name,
      },
    });
    setDeleteItemModal(true);
    handleClose();
  };

  const handleToggleActiveAction = () => {
    if (Freeze == 1) {
      return handleFreeze();
    }
    if (isUpdatingItem) {
      return showWarningSnackbar('Please wait, updating item...');
    }
    setActiveValueModal(row);
    handleClose();
  };

  const handleCreateCategoryAction = (e) => {
    if (Freeze) {
      return handleFreeze();
    }
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    } else {
      setParent(row);
      setMainCategory(row?.type);
      setCreateGroupModal(true);
    }
    handleClose();
  };

  const handleCreateItemAction = (e) => {
    if (Freeze) {
      return handleFreeze();
    }
    if (saveSkipStatus == false) {
      dispatch(settingsClose());
      navigate('/companysetup');
    } else {
      setParent(row);
      setCreateLedgerModal(true);
      setMainCategory(row?.type);
    }
    handleClose();
  };

  const newItemChip = (nodeId) => {
    if (newAddedCategoryId?.includes(nodeId)) {
      return (
        <Chip
          key={nodeId}
          size="small"
          sx={{
            marginLeft: '2px',
            backgroundColor: '#e63f66',
            color: '#ffff',
          }}
          label="New"
        />
      );
    }
  };

  return (
    <>
      <Box sx={{  width: {xs:"45%", sm:"55%"}, height: '100%', overflow: 'hidden' }}>
        <Box
          className="tree-row-container"
          sx={{
            borderRight: `4px solid ${borderRightColor}`,
            height: '100%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              paddingLeft: `${row.depth * 10}px`,
              display: 'flex',
              alignItems: 'center',
              height: '100%',
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
            }}
          >
            {row?.category === 'Category' ? (
              <IconButton
                aria-label={isExpand ? 'collapse' : 'expand'}
                size="small"
                onClick={(e) => handleToggle(e, row?.id)}
                style={{ padding: 0, margin: 0, flexShrink: 0 }}
              >
                {isExpand ? <ArrowDropDown sx={{ margin: 0, padding: 0 }} /> : <ArrowRight sx={{ margin: 0, padding: 0 }} />}
              </IconButton>
            ) : (
              <IconButton size="small" style={{ padding: 0, margin: 0, flexShrink: 0 }}>
                <Circle
                  sx={{
                    width: 10,
                    height: 10,
                    color: '#ee5b2b',
                    marginLeft: '7px',
                    marginRight: '5px',
                  }}
                />
              </IconButton>
            )}

            <Tooltip arrow title={`${row?.name}`}>
              <Typography
                className={row?.category !== 'Category' ? 'myLink' : ''}
                variant="body1"
                sx={{
                  ...(isCategory
                    ? {
                        fontWeight: 'bold',
                        fontSize: '13px',
                        color: 'primary.main',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        cursor: 'default',
                      }
                    : {
                        cursor: 'pointer',
                        fontWeight: row?.is_active ? '' : 'bold',
                        color: row?.is_active ? '' : '#cccccc',
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        flex: 1,
                        minWidth: 0,
                      }),
                }}
                onClick={
                  row?.category !== 'Category'
                    ? (e) => {
                        e.stopPropagation();
                        setItemModal(true);
                        setItemDetails({
                          itemId: row?.id,
                          type: row?.type,
                          view: true,
                          name: row?.name,
                        });
                      }
                    : undefined
                }
              >
                {row?.name}
                {newItemChip(row?.id)}
              </Typography>
            </Tooltip>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              marginLeft: 'auto',
              marginRight: '3px',
            }}
          >
            {isMobile ? (
              <>
                <IconButton
                  onClick={handleClick}
                  size="small"
                  sx={{ padding: '4px' }}
                >
                  <MoreVert />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  sx={{
                    visibility: visi ? 'visible' : 'hidden',
                  }}
                >
                  {row?.category !== 'Category' ? (
                    <>
                      {row?.is_active && (
                        <MenuItem onClick={handleEditAction}>
                          <IconButton size="small" sx={{ mr: 1 }}>
                            ✏️
                          </IconButton>
                        </MenuItem>
                      )}
                      <MenuItem onClick={handleDeleteAction}>
                        <IconButton size="small" sx={{ mr: 1 }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15">
                            <path
                              d="M5.755 20.283 4 8h16l-1.755 12.283A2 2 0 0 1 16.265 22h-8.53a2 2 0 0 1-1.98-1.717zM21 4h-5V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2z"
                              fill="#ff0000"
                            />
                          </svg>
                        </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleToggleActiveAction}>
                        <IconButton size="small" sx={{ mr: 1 }}>
                          {row?.is_active ? (
                            <CheckCircleOutline sx={{ fontSize: 15, color: "green" }} />
                          ) : (
                            <DoDisturbAlt sx={{ fontSize: 15, color: "red" }} />
                          )}
                        </IconButton>
                      </MenuItem>
                    </>
                  ) : (
                    <>
                      <MenuItem onClick={handleCreateCategoryAction}>
                        <IconButton size="small" sx={{ mr: 1 }}>
                          <span style={{ 
                            backgroundColor: theme.palette.primary.main,
                            color: 'white',
                            borderRadius: '20%',
                            width: '20px',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            fontSize:"12px"
                          }}>
                            C
                          </span>
                        </IconButton>
                      </MenuItem>
                      <MenuItem onClick={handleCreateItemAction}>
                        <IconButton size="small" sx={{ mr: 1 }}>
                          <span style={{ 
                            backgroundColor: theme.palette.secondary.main,
                            color: 'white',
                            borderRadius: '20%',
                            width: '20px',
                            height: '20px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                             fontSize:"12px"
                          }}>
                            I
                          </span>
                        </IconButton>
                      </MenuItem>
                    </>
                  )}
                  {!isCategory && row?.is_active && (
                    <MenuItem onClick={handleClose}>
                      <VoucherBTNnew key={row?.id} item={row} theme={theme} setVisi={setVisi}/>
                    </MenuItem>
                  )}
                </Menu>
              </>
            ) : (
              <Stack direction="row" spacing={1}>
                {row?.category !== 'Category' ? (
                  <>
                    {row?.is_active && (
                      <Tooltip title={`Edit `} placement="bottom" arrow>
                        <button
                          className="button-container"
                          style={{
                            backgroundColor: '#ffff',
                            border: 'none',
                            flexDirection: 'column',
                            borderRadius: '4px',
                            height: '25px',
                            width: '25px',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginLeft: 10,
                            cursor: 'pointer',
                          }}
                          onClick={handleEditAction}
                        >
                          ✏️
                        </button>
                      </Tooltip>
                    )}
                    <Tooltip title={`Delete `} placement="bottom" arrow>
                      <button
                        className="button-container"
                        style={{
                          backgroundColor: '#ffff',
                          border: 'none',
                          flexDirection: 'column',
                          borderRadius: '4px',
                          height: '25px',
                          width: '25px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginLeft: 10,
                          cursor: 'pointer',
                        }}
                        onClick={handleDeleteAction}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="15" height="15">
                          <path
                            d="M5.755 20.283 4 8h16l-1.755 12.283A2 2 0 0 1 16.265 22h-8.53a2 2 0 0 1-1.98-1.717zM21 4h-5V3a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1H3a1 1 0 0 0 0 2h18a1 1 0 0 0 0-2z"
                            fill="#ff0000"
                          />
                        </svg>
                      </button>
                    </Tooltip>
                    <Tooltip title={row?.is_active ? 'Mark as In-Active' : 'Mark as Active'} placement="bottom" arrow>
                      <button
                        className="button-container"
                        style={{
                          backgroundColor: '#ffff',
                          border: 'none',
                          flexDirection: 'column',
                          borderRadius: '4px',
                          height: '25px',
                          width: '25px',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginLeft: 10,
                          cursor: 'pointer',
                        }}
                        onClick={handleToggleActiveAction}
                      >
                        {row?.is_active ? (
                          <CheckCircleOutline sx={{ fontSize: 15, color: "green", }} />
                        ) : (
                          <DoDisturbAlt sx={{ fontSize: 15, color: "red" }} />
                        )}
                      </button>
                    </Tooltip>
                  </>
                ) : null}
                {isCategory && (
                  <>
                    <Tooltip title="Create new category">
                      <button
                        className="letter-button enabled"
                        style={{
                          backgroundColor: theme.palette.primary.main,
                          boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                        }}
                        onClick={handleCreateCategoryAction}
                      >
                        C
                      </button>
                    </Tooltip>
                    <Tooltip title="Create Item">
                      <button
                        className="letter-button enabled"
                        style={{
                          backgroundColor: theme.palette.secondary.main,
                          boxShadow: '0px 6px 8px rgba(0, 0, 0, 0.5)',
                        }}
                        onClick={handleCreateItemAction}
                      >
                        I
                      </button>
                    </Tooltip>
                  </>
                )}
                {!isCategory && (
                  <>
                    {row?.is_active ? (
                      <VoucherBTNnew key={row?.id} item={row} theme={theme} />
                    ) : (
                      <button
                        className="letter-button disabled"
                        style={{
                          backgroundColor: '#e0e0e0',
                        }}
                      >
                        V
                      </button>
                    )}
                  </>
                )}
              </Stack>
            )}
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: {xs:'10%',sm:'8%'}, height: '100%',  }}>
        <Box
          sx={{
            borderRight: `4px solid ${borderRightColor}`,
            px: 1,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          <Typography
            sx={{ 
              fontSize: '13px', 
              fontWeight: 'bold',
              textAlign: 'center',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap'
            }}
          >
            {isCategory ? '' : 
              (row?.category === 'Item' && row?.type === 'SERVICE') || (row?.category === 'Category' && row?.type === 'Services') ? '' : 
              row?.unit || ''}
          </Typography>
        </Box>
      </Box>
      <Box sx={{width: {xs:'20%',sm:'18%'}, height: '100%',  }}>
        <Box
          sx={{
            borderRight: `4px solid ${borderRightColor}`,
            px: 1,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Typography 
            sx={{ 
              fontSize: '13px', 
              fontWeight: 'bold',
              textAlign: 'right',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              // Color coding for quantity: red if negative, blue for zero and positive
              ...(row?.category === 'Item' && row?.qty !== '' && row?.qty !== undefined && row?.type !== 'SERVICE' ? {
                color: row?.qty < 0 ? '#d32f2f' : '#2196f3',
                // Make clickable for all items with quantity value (including negative and zero)
                cursor: 'pointer',
                textDecoration: 'underline',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              } : {})
            }}
            onClick={(e) => {
              // Make clickable for all items with quantity value (including negative and zero)
              if (row?.category === 'Item' && row?.qty !== '' && row?.qty !== undefined && row?.type !== 'SERVICE' && handleClosingStockClick) {
                e.stopPropagation();
                handleClosingStockClick(row);
              }
            }}
          >
            {isCategory ? '' : 
              (row?.category === 'Item' && row?.type === 'SERVICE') || (row?.category === 'Category' && row?.type === 'Services') ? '' : 
              row?.qty === '' ? '' : row?.qty}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ width: {xs:'25%',sm:'19%'}, height: '100%',  }}>
        <Box
          sx={{
            height: '100%',
            display: 'flex',
            px: 1,
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          <Typography
            sx={{ 
              fontSize: '13px', 
              fontWeight: 'bold',
              textAlign: 'right',
              width: '100%',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              // Color coding for amount: red if negative, blue for zero and positive
              // Make clickable for all items with amount value (including negative and zero)
              ...(row?.category === 'Item' && row?.price !== '' && row?.price !== undefined && row?.type !== 'SERVICE' ? {
                color: row?.price < 0 ? '#d32f2f' : '#2196f3',
                cursor: 'pointer',
                textDecoration: 'underline',
                '&:hover': {
                  backgroundColor: '#f5f5f5',
                },
              } : 
              // For categories, also apply color coding but no link
              (row?.category === 'Category' && row?.price !== '' && row?.price !== undefined && row?.type !== 'Services' ? {
                color: row?.price < 0 ? '#d32f2f' : 'inherit',
              } : {}))
            }}
            onClick={(e) => {
              // Make clickable for all items with amount value (including negative and zero)
              if (row?.category === 'Item' && row?.price !== '' && row?.price !== undefined && row?.type !== 'SERVICE' && handleClosingStockClick) {
                e.stopPropagation();
                handleClosingStockClick(row);
              }
            }}
          >
            {isCategory && hideGroupTotal ? '' : 
              (row?.category === 'Item' && row?.type === 'SERVICE') || (row?.category === 'Category' && row?.type === 'Services') ? '' : 
              row?.price === '' ? '' : `₹ ${MoneyFormatv3(row?.price)}`}
          </Typography>
        </Box>
      </Box>
    </>
  );
};
